import { gql } from 'Utils/apolloClient'

const campgroundQuery = gql`
  query Campground($slug: String!) {
    campground(slug: $slug) {
      sitesCountByType
    }
  }`

export default campgroundQuery
